import { Action } from '@ngrx/store';
import { Page } from './course-player.reducer';

export const CLOSE = "[Page] Close";
export const SHOW_TIPS = "[Page] Show Tips";

export const ZOOM = "[Page] Zoom";

export const PAGE_RIGHT = "[Page] Page Right";
export const PAGE_LEFT = "[Page] Page Left";
export const LOAD = "[Page] Load";
export const LOAD_PROGRESS = "[Page] Load Progress";

export const PAUSE = "[Audio] Pause";
export const PLAY = "[Audio] Play";

export const SKIP_BACK = "[Audio] Skip Back";
export const SKIP_FORWARD = "[Audio] Skip Forward";

export const AUDIO_SCRUB_UPDATE = "[Audio] Audio Scrub Update";
export const AUDIO_SCRUB_INTERVAL = "[Audio] Audio Scrub Interval";

export const DOUBLE_TAP = "[Content] Double Tap";

export class AudioScrubUpdate implements Action {
    readonly type = AUDIO_SCRUB_UPDATE;
    constructor(public audioSeek: number) {}
}

export class AudioScrubInterval implements Action {
    readonly type = AUDIO_SCRUB_INTERVAL;
    constructor(public audioSeek: number) {}
}

export class Zoom implements Action {
    readonly type = ZOOM;
    constructor() {}
}

export class PageRight implements Action {
    readonly type = PAGE_RIGHT;
    constructor() {}
}

export class PageLeft implements Action {
    readonly type = PAGE_LEFT;
    constructor() {}
}

export class Close implements Action {
    readonly type = CLOSE;
    constructor() {}
}

export class ShowTips implements Action {
    readonly type = SHOW_TIPS;
    constructor() {}
}

export class Load implements Action {
    readonly type = LOAD;
    constructor(public pages: Page[], public courseId, public audioUrl, public moduleName, public unitName, public loadLastPage = false) {}
}

export class LoadProgress implements Action {
    readonly type = LOAD_PROGRESS;
    constructor(public state: any) {}
}

export class Pause implements Action {
    readonly type = PAUSE;
    constructor() {}
}

export class Play implements Action {
    readonly type = PLAY;
    constructor() {}
}

export class SkipBack implements Action {
    readonly type = SKIP_BACK;
    constructor() {}
}

export class SkipForward implements Action {
    readonly type = SKIP_FORWARD;
    constructor() {}
}

export class DoubleTap implements Action {
    readonly type = DOUBLE_TAP;
    constructor() {}
}

export type PageActions
= PageRight
| PageLeft
| AudioScrubUpdate
| AudioScrubInterval
| Zoom
| Close
| ShowTips
| Load
| LoadProgress
| Pause
| Play
| DoubleTap
| SkipBack
| SkipForward;